import React, { useState } from 'react'
import { Select } from 'antd'

import 'antd/dist/antd.css';
//@ts-ignore
import s from './SelectStandard.module.scss'
import { ArrowTriangleBlack } from '../../../asset/icon/ArrowTriangleBlack';

import { SelectSearchIcon } from '../../../asset/icon/SelectSearchIcon';

import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { setValueOptions } from '../../../store/actions/setting';
import { getValueOption, valueOption } from '../../../store/selectors/selectors';

export type valueSelect = {
    value: string,
    label: string,
}

export type selectStandardT = {
    values: valueSelect[]
    id: string
    parentKeySection?: unknown
}

type getIconT = {
    showSearch: boolean,
    open: boolean,
    focused: boolean,
}

const StyledSelectFunc = ({ ...props }) => styled(Select)`
    .ant-select{
        width: 100% !important;
    }
    .ant-select-selector {
        border: 1px solid #dedede !important;
        box-sizing: border-box !important;
        border-radius: 15px !important;
        height: 42px !important;
        cursor: pointer !important;
        ${!!props['isError'] && `border: 1px solid #DE5555 !important;`}
        &  .ant-select-selection-placeholder{
            color: #6a6a63 !important;
            font-size: 15px !important;
            line-height: 40px !important;
        }
        & .ant-select-selection-item{
            color: #6a6a63 !important;
            font-size: 15px !important;
            line-height: 40px !important;
        }
    }
    .selectStandard_error .ant-select-selector{
        border: 1px solid red !important;
    }
`;


export const SelectStandard = ({ ...props }: selectStandardT) => {

    const { values, id, parentKeySection } = props;

    const dispatch = useDispatch();

    let { selectValue, isError }: valueOption = useSelector(state => getValueOption({idOptions: id, parentKeySection})(state));

    const { Option } = Select;

    let params = ['Barn Width', 'Wall Height', 'Barn Length']

    function onChange(value: any) {
        let param: any = props;
        if (params.includes(param['id'])) {
            window.configurator.setConfiguration({ [param['id']]: value })
        }

        dispatch(setValueOptions({ idParams: id, valueParam: value, parentKeySection: parentKeySection }))

    }

    function onBlur() {
        console.log('blur');
    }

    function onFocus() {
        console.log('focus');
    }

    function onSearch(val: any) {
        console.log('search:', val);
    }



    let classInput = `${s.selectStandard}`

    function getIcon({ ...props }: getIconT): React.ReactNode {

        const { showSearch, open } = props

        let iconClass = `${s.iconSelect}`
        if (!!selectValue) iconClass += ` ${s.rotated}`

        if (open && showSearch) {
            return <SelectSearchIcon />
        }
        return <ArrowTriangleBlack className={iconClass} />;
    }

    let StyledSelect = StyledSelectFunc({ isError: isError })

    return (
        <div className={s.boxSelect}>
            <StyledSelect
                className={classInput}
                showSearch
                suffixIcon={getIcon}

                placeholder="Select value"
                optionFilterProp="children"
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                value={selectValue}
            >
                {values.map(option => {
                    return <Option key={option['value']} value={option['value']} > {option['label']}</Option>
                })}
            </StyledSelect>
        </div >
    )
}




